import { Skeleton } from '@/common/components/Skeleton'

export const RedemptionHistoryCardSkeleton = () => {
  return (
    <div className="rounded-lg bg-white-100 border border-white-400 p-4 flex flex-col gap-3">
      <div className="flex flex-col gap-1">
        <Skeleton width={100} height={16} />

        <Skeleton width={160} height={20} />
      </div>

      <div className="grid grid-cols-2 gap-2">
        <div className="bg-white-200 rounded-md p-3 flex flex-col gap-1.5">
          <Skeleton width={80} height={16} />

          <Skeleton width="70%" height={18} />
        </div>

        <div className="bg-white-200 rounded-md p-3 flex flex-col gap-1.5">
          <Skeleton width={60} height={16} />

          <Skeleton width={50} height={18} />
        </div>
      </div>

      <div className="grid grid-cols-2 gap-2">
        <div className="bg-white-200 rounded-md p-3 flex flex-col gap-1.5">
          <Skeleton width={70} height={16} />

          <Skeleton width="80%" height={18} />
        </div>

        <div className="bg-white-200 rounded-md p-3 flex flex-col gap-1.5">
          <Skeleton width={120} height={16} />

          <Skeleton width="60%" height={18} />
        </div>
      </div>
    </div>
  )
}
